(function ($, window, document, undefined) {

	const pluginName = 'fbSDK';

	class FacebookSDK {

		constructor(element, options) {

			this._name = pluginName;
			this._defaults = $.fn[pluginName].defaults;

			this.element = element;
			this.options = $.extend({}, this._defaults, options);

			this.init();

		}

		init() {
			this.cacheElements();

			// Register the method to run after the Facebook SDK script is loaded
			window.fbAsyncInit = this.asyncInit.bind(this);

			this.loadScript();
		}

		cacheElements() {
			this.$element = $(this.element);
		}

		asyncInit() {
			if (this.options.appId) {
				window.FB.init({
					appId: this.options.appId,
					version: this.options.version
				});
			}

			this.$element.trigger(`${pluginName}:load`);
		}

		loadScript() {
			var d = document;
			var s = 'script';
			var id = 'facebook-jssdk';

			var js, fjs = d.getElementsByTagName(s)[0];
			if (d.getElementById(id)) return;
			js = d.createElement(s);
			js.id = id;
			js.src = `//connect.facebook.net/${this.options.language}/sdk.js#xfbml=1&version=${this.options.version}`;
			fjs.parentNode.insertBefore(js, fjs);
		}
	}

	$.fn[pluginName] = function (options) {
		return this.each(function () {
			if (!$.data(this, 'plugin_' + pluginName)) {
				$.data(this, 'plugin_' + pluginName, new FacebookSDK(this, options));
			}
		});
	};

	$.fn[pluginName].defaults = {
		appId: $('meta[property="fb:app_id"]').attr('content'),
		version: 'v9.0',
		language: 'pt_BR'
	};

	$.fbSDK = {
		graphData: false,
		fetchGraphData: function () {
			if (this.graphData) {
				return;
			}

			this.graphData = true;

			var graphUrl = $('meta[property="og:url"]')
				.attr('content')
				.replace(CANONICAL_URL, '')
				.replace(/\//g, '_');

			/*
			$.get(BASE_URL + 'estatisticas/engajamento/' + graphUrl, function (data) {
				$(document).trigger('fbSDK:graph:data:load', data);
			}, "json");
			*/
		}
	};

})(jQuery, window, document);
